import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AppEvent } from '../models/app-event';
import { extractErrorMessage } from '../utils/utils';
import { DateTime } from 'luxon';
import { SimilarityList } from '../models/similarity-list';

export interface EventSimilarityCheckPayload {
  id: number | null;
  name: string | null;
  date: string | null;
}

export interface EventSimilarityRecord {
  id: number;
  name: string;
  date: string;
  nameSimilarity: number;
  emailSimilarity: number;
}

@Injectable({
  providedIn: 'root'
})
export class EventService {
  baseUrl: string = environment.api_url;
  constructor(private http: HttpClient) { }

  checkForSimilarEvents(data: EventSimilarityCheckPayload): Observable<SimilarityList<EventSimilarityRecord>> {
    let params = new HttpParams();
    for (const key in data) {
      const value = (data as any)[key];
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, value);
      }
    }
    return this.http.get<SimilarityList<EventSimilarityRecord>>(`${this.baseUrl}/events/similar`, { params }).pipe(
      catchError(err => throwError(() => extractErrorMessage(err)))
    );
  }

  // GET all events
  getAllEvents(): Observable<AppEvent[]> {
    return this.http.get<AppEvent[]>(`${this.baseUrl}/events`).pipe(
      map(list => list.map(dto => new AppEvent(dto))),
      catchError(err => throwError(() => extractErrorMessage(err)))
    );
  }

  // GET single event by ID
  getEventById(id: number): Observable<AppEvent> {
    return this.http.get<AppEvent>(`${this.baseUrl}/events/${id}`).pipe(
      map(dto => new AppEvent(dto)),
      catchError(err => throwError(() => extractErrorMessage(err)))
    );
  }

  // GET all events
  getSortedEvents(sortBy: string): Observable<AppEvent[]> {
    return this.http.get<AppEvent[]>(`${this.baseUrl}/events?sort=${sortBy}`).pipe(
      map(list => list.map(dto => new AppEvent(dto))),
      catchError(err => throwError(() => extractErrorMessage(err)))
    );
  }


  // create(event: AppEvent): Observable<void> {
  //   return this.http.post<void>(`${this.baseUrl}/events`, AppEvent).pipe(
  //     catchError(err => throwError(() => extractErrorMessage(err)))
  //   );
  // }
  create(event: AppEvent): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/events`, event).pipe(
      catchError(err => throwError(() => extractErrorMessage(err)))
    );
  }
  update(event: AppEvent): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/events/${event.id}`, event).pipe(
      catchError(err => throwError(() => extractErrorMessage(err)))
    );
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/events/${id}`).pipe(
      catchError(err => throwError(() => extractErrorMessage(err)))
    );
  }
}
